import React, { useEffect, useState } from 'react'
import "./styles.css"
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
//@ts-ignore
import userLogo from "../../assets/user.svg"
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch, useAppSelector } from '../../redux/store'
import { login, resetLoginSuccess } from '../../redux/slices/authSlice'
import useWindowSize from '../../utils/useWindowSize'




const validationSchema = Yup.object({
    userName: Yup.string()
        .required('Kullanıcı adı zorunludur.'),
    password: Yup.string()
        .required('Parola zorunludur.')
});


export default function Login() {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const isSucceed = useAppSelector(state => state.auth.onLoginSuccess)

    const error = useAppSelector(state => state.auth.loginErr)

    const [width, _] = useWindowSize()

    useEffect(() => {
        if (isSucceed) {
            navigate("/")
            setTimeout(() => {
                dispatch(resetLoginSuccess())
            }, 3000);
        }
    }, [isSucceed])

    const formData = useFormik({
        initialValues: {
            userName: '',
            password: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(login({
                username: values.userName,
                password: values.password
            }))

        }
    })



    return (
        <div className='login-page' style={{ padding: width < 800 ? "0 50px 0 50px" : "0", height: width < 800 ? "32rem" : "34rem" }}>
            <div className='login-container'>
                <div className='login-header' style={{ padding: width < 800 ? "1rem 1.5rem 1.5rem 1.5rem" : "1.5rem 1.5rem 2.5rem 1.5rem" }}>
                    <h2>Hoşgeldiniz</h2>
                    <div className='usr-div'>
                        <img src={userLogo} width={70} height={85} />
                    </div>
                </div>
                <div className='form-container'>
                    <Form
                        onSubmit={e => {
                            formData.handleSubmit()
                            e.preventDefault()

                            return false
                        }}
                        action='#'
                    >
                        <FormGroup>
                            <Label className='ms-1'>Kullanıcı Adı</Label>
                            <Input
                                id='userName'
                                name="userName"
                                type='text'
                                onChange={formData.handleChange}
                                onBlur={formData.handleBlur}
                                value={formData.values.userName}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label className='ms-1'>Şifre</Label>
                            <Input
                                id="password"
                                name="password"
                                type="password"
                                onChange={formData.handleChange}
                                onBlur={formData.handleBlur}
                                value={formData.values.password}
                            />
                        </FormGroup>
                        {/* {error && <div style={{ color: "red", textAlign: "center" }}>{error}</div>} */}
                        {formData.touched.password && formData.errors.password ? (
                            <div style={{ color: "red", textAlign: "center" }}>{formData.errors.password}</div>
                        ) : null}
                        {error && <div style={{ color: "red", textAlign: "center" }}>{error}</div>}
                        <div className='btn-div' style={{ marginBottom: width < 800 ? "30px" : "0" }}>
                            <Button outline className='login-btn' type='submit' >
                                Giriş
                            </Button>
                        </div>

                    </Form>
                </div>

            </div>
        </div>
    )
}
